import { render } from "./App.vue?vue&type=template&id=5c36dca2&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=5c36dca2&scoped=true&lang=css"
import "./App.vue?vue&type=style&index=1&id=5c36dca2&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c36dca2"]])

export default __exports__